import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastProvider } from './ui';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { queryClient } from './config/queryClient';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import BarcodeScanner from './components/BarcodeScanner';
import DressManagement from './components/DressManagement';
import CustomerManagement from './components/CustomerManagement';
import BrandManagement from './components/BrandManagement';
import CategoryManagement from './components/CategoryManagement';
import RentalManagement from './components/RentalManagement';
import BranchManagement from './components/BranchManagement';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user ? <>{children}</> : <Navigate to="/login" />;
};

const AppRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to="/scanner" /> : <Login />} 
      />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/scanner" />} />
        <Route path="scanner" element={<BarcodeScanner />} />
        <Route path="dresses" element={<DressManagement />} />
        <Route path="customers" element={<CustomerManagement />} />
        <Route path="brands" element={<BrandManagement />} />
        <Route path="categories" element={<CategoryManagement />} />
        <Route path="branches" element={<BranchManagement />} />
        <Route path="rentals" element={<RentalManagement />} />
      </Route>
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <Router>
            <AppRoutes />
          </Router>
        </AuthProvider>
      </ToastProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App; 